import("./bootstrap"); // REMOVE PARENTHESIS AND YOU DIE, WE NEED ASYNC MODULE LOADING.
